module.exports = __webpack_public_path__ + "img/timeline_miscevent-1.7bb3872c.jpg";